<div class="card">
    <div class="card-body">
        <button type="button" class="btn-close reason-cross" (click)="sms_mobile_numbers = []; modalRef.hide()"
            aria-label="Close"></button>
        <p class="avatar-text mb-4"> Send SMS to {{first_name }} {{last_name }}</p>

        <div class="phone_numbers">
            <div class="m-2 p-2 phone_number_row" *ngFor='let phone_details of sms_mobile_numbers; index as i'>
                <p class="mb-0">{{phone_details.dial_code}}- {{phone_details.mobile_no}} </p>
                <button type="button" class="ms-4 btn btn-primary" (click)="removePhoneNumber(i)">X</button>
            </div>
        </div>


        <div>
            <p class="mb-1">Send message to number given bellow</p>
            <div class="add_phone_no.">
                <input class="input_tel dial-code" type="text" placeholder="Dial Code" (input)="setSmsDialCode($event)"
                    [value]="sms_dial_code" [disabled]="true"/>
                <input class="input_tel ms-2"  maxlength="10" placeholder="Phone No." type="text" mask="0000000000"
                    (input)="setSmsMobile($event)" [ngModel]="sms_mobile" />
                <button type="button" class="ms-4 btn btn-primary" (click)="addPhoneNumber()"
                    [disabled]="!(sms_mobile.length > 9 &&  sms_dial_code.length > 0)">+</button>
            </div>
        </div>
        <div class="send_message_content">
            <p class="">Message</p>
            <textarea class="send_message_content_input" name="" id="" [(ngModel)]="sms_text" (input)="setMessage($event)"></textarea>
        </div>
        <button type="button" class="btn btn-primary mt-3" (click)="sendSMS()"
            [disabled]="!(sms_mobile_numbers.length > 0 && sms_text.length)">
            Send SMS
        </button>
    </div>
</div>